export default "__VITE_ASSET__4d66bfe9__"